// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + (chunkId === 777 ? "recorder" : chunkId) + "." + {"453":"f9868307","777":"cd6e6d92"}[chunkId] + ".chunk.js";
};